import { useNavigate } from 'react-router-dom';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';

import { PATH } from 'constants/path';

export const useAdminLayoutController = () => {
  const navigate = useNavigate();
  const userProfile = useAuthStore(userProfileSelector);

  const isSuperAdmin = userProfile?.isSuperAdmin || false;

  const onClickAdd = () => {
    navigate(`${PATH.ADMINS}/${PATH.ADD_ADMIN}`);
  };

  return {
    onClickAdd,
    isSuperAdmin,
  };
};
